import rootStore from '../../../store/RootStore'
import { Box, ButtonGroup, Icon, Menu, MenuButton } from '@chakra-ui/react'
import React, { useCallback, useContext, useMemo } from 'react'

import { LayoutContext } from '../../ui/Layout/Layout'
// import { SearchDialog } from '../Search/SearchDialog'
import ButtonIcon from '../../ui/ButtonIcon'
import { AiOutlineDownload } from 'react-icons/ai'
// import { BiMessageDetail } from 'react-icons/bi'
import CustomMenuList from '../../ui/CustomMenuList/CustomMenuList'
import SnapshotControls from './SnapshotControls'
import { FiMoreVertical } from 'react-icons/fi'
import { observer } from 'mobx-react'
import { ReportContext } from '../../../contexts/ReportContext'
// import { NavbarHidableItems } from './Navbar'
// import { NavbarContext } from '../../../contexts/NavbarContext'

const NavbarButtons = observer(({ small }) => {
  const {
    searchStore: { setSearchText, setSearchDrawerVisible },
    commentStore: { setCommentsDrawerVisible, commentsDrawerVisible },
  } = rootStore

  const reportContext = useContext(ReportContext)
  const { onToggleRightPanel } = useContext(LayoutContext)
  // const { hideItems } = useContext(NavbarContext)

  const handleToggleCommentsVisible = useCallback(() => {
    setCommentsDrawerVisible(!commentsDrawerVisible)
    onToggleRightPanel(currentIsRightPanelOpen => !currentIsRightPanelOpen)
  }, [commentsDrawerVisible, onToggleRightPanel, setCommentsDrawerVisible])

  const handleSearch = useCallback(
    ({ searchText }) => {
      setSearchDrawerVisible(true)
      setSearchText(searchText)
      onToggleRightPanel(true)
    },
    [onToggleRightPanel, setSearchDrawerVisible, setSearchText],
  )
  return (
    <>
      <Box
        display={{
          base: 'none',
          md: small ? 'none' : 'block',
          lg: 'block',
        }}>
        <ButtonGroup
          spacing="3"
          ml={{ base: 0, lg: '24px' }}
          position="relative">
          {/*{!hideItems.includes(NavbarHidableItems.SearchButton) && (*/}
          {/*  <MemoSearchButton onSearchSubmit={handleSearch} />*/}
          {/*)}*/}
          {/*<ButtonIcon*/}
          {/*  onClick={handleToggleCommentsVisible}*/}
          {/*  active={commentsDrawerVisible}*/}
          {/*  data-testid="comments-button">*/}
          {/*  <BiMessageDetail size={20} />*/}
          {/*</ButtonIcon>*/}
          <SnapshotControls />
          <ButtonIcon
            onClick={reportContext.onDownloadToggle}
            active={reportContext.isDownloadOpen}
            data-testid="download-button">
            <AiOutlineDownload size={20} />
          </ButtonIcon>
        </ButtonGroup>
      </Box>
      <Box
        display={{
          base: 'block',
          md: small ? 'block' : 'none',
          lg: 'none',
        }}>
        <NavbarButtonsMobile
          onToggleComment={handleToggleCommentsVisible}
          onToggleSearch={handleSearch}
        />
      </Box>
    </>
  )
})

// const SearchButton = observer(({ onSearchSubmit }) => {
//   const { isOpen, onClose, onToggle } = useDisclosure()
//   const {
//     searchStore: { searchDrawerVisible },
//   } = rootStore
//
//   return (
//     <SearchDialog
//       onClose={onClose}
//       isOpen={isOpen}
//       onSubmit={onSearchSubmit}>
//       <ButtonIcon
//         onClick={onToggle}
//         active={searchDrawerVisible}
//         data-testid="search-button">
//         <AiOutlineSearch size={20} />
//       </ButtonIcon>
//     </SearchDialog>
//   )
// })
// const MemoSearchButton = React.memo(SearchButton)

const NavbarButtonsMobile = React.memo(() =>
  // {
  //   onToggleComment, onToggleSearch
  // },
  {
    const { onDownloadToggle } = useContext(ReportContext)
    // const { hideItems } = useContext(NavbarContext)

    const navbarMenuItems = useMemo(
      () => [
        // ...[
        //   !hideItems.includes(NavbarHidableItems.SearchButton) && {
        //     id: '1',
        //     label: 'Search',
        //     action: () => onToggleSearch({ searchText: '---' }),
        //     icon: <AiOutlineSearch size={20} />,
        //   },
        // ],
        // {
        //   id: '2',
        //   label: 'Comments',
        //   action: onToggleComment,
        //   icon: <BiMessageDetail size={20} />,
        // },
        {
          id: '3',
          label: 'Download',
          action: onDownloadToggle,
          icon: <AiOutlineDownload size={20} />,
        },
      ],
      [
        //  hideItems,
        onDownloadToggle,
        // onToggleComment,
        // onToggleSearch
      ],
    )
    return (
      <Menu>
        <MenuButton
          borderRadius="100%"
          boxShadow="1px 1px 3px rgba(0, 0, 0, .1)"
          w={10}
          h={10}
          p={0}>
          <Icon
            as={FiMoreVertical}
            fontSize={20}
            mt={'5px'}
          />
        </MenuButton>

        <CustomMenuList items={navbarMenuItems} />
      </Menu>
    )
  },
)

export { NavbarButtons }
